module.exports = "<div class=\"form-inline\">\n  <h3>Channel:</h3>\n  <select class=\"form-control\" [(ngModel)]=\"inputChannel\">\n    <option *ngFor=\"let channelNumber of channelNumbers\" [value]=channelNumber>{{channelNumber}}</option>\n  </select>\n\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"nextQueue()\">Submit</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-controls/admin-controls.component.html
// module id = 166
// module chunks = 1